import React from 'react';
import {
  Box,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  GridPagination,
  useGridApiContext,
  useGridSelector,
  gridPageCountSelector,
  gridPageSelector,
} from '@mui/x-data-grid';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';

const CustomPagination = () => {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  const handleFirstPageClick = () => {
    apiRef.current.setPage(0);
  };

  const handleLastPageClick = () => {
    apiRef.current.setPage(pageCount - 1);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Tooltip title="Primeira página">
          <span>
            <IconButton
              onClick={handleFirstPageClick}
              disabled={page === 0}
              size="small"
              sx={{ mr: 1 }}
            >
              <FirstPageIcon />
            </IconButton>
          </span>
        </Tooltip>
      </Box>
      <GridPagination />
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Tooltip title="Última página">
          <span>
            <IconButton
              onClick={handleLastPageClick}
              disabled={page === pageCount - 1}
              size="small"
              sx={{ ml: 1 }}
            >
              <LastPageIcon />
            </IconButton>
          </span>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default CustomPagination; 